/* Jurassic Modern: reliable click-accessible overflow navigation. */
(function() {
  function setMoreState(menu, open) {
    if (!menu) return;
    var button = menu.querySelector(':scope > button');
    menu.dataset.jhOpen = open ? 'true' : 'false';
    menu.classList.toggle('site-nav--active', open);
    if (button) button.setAttribute('aria-expanded', String(open));
  }

  function closeMore(except) {
    document.querySelectorAll('#moreMenu').forEach(function(menu) {
      if (menu !== except) setMoreState(menu, false);
    });
  }

  document.addEventListener('click', function(event) {
    var button = event.target.closest('#moreMenu > button');

    if (button) {
      event.preventDefault();
      event.stopImmediatePropagation();

      var menu = button.closest('#moreMenu');
      var open = menu.dataset.jhOpen !== 'true';

      closeMore(menu);
      setMoreState(menu, open);
      return;
    }

    if (!event.target.closest('#moreMenu')) closeMore(null);
  }, true);

  document.addEventListener('keydown', function(event) {
    if (event.key !== 'Escape') return;
    closeMore(null);
    var button = document.querySelector('#moreMenu > button');
    if (button) button.focus();
  });
})();
